import { createLink } from "@tanstack/react-router";
import styled from "styled-components";

const StyledAnchor = styled.a`
    border: 1px solid grey;
    padding: 2px 7px;
    border-radius: 4px;
    color: black;
    text-decoration: none;
    &:hover,
    &:focus,
    &:active,
    &:visited {
        color: black;
    }
    &.active {
        font-weight: bold;
    }
`;
const StyledLink = createLink(StyledAnchor);

const Nav = styled.nav`
    display: flex;
    gap: 3px;
    margin-bottom: 0.5rem;
`;

const Span = styled.span`
    padding: 2px 7px;
    font-size: 1.2rem;
`;

interface IProps {
    page: number;
    maxPage: number;
    contentType: "texts" | "docs" | "default-content";
    version: string;
}

function range(start: number, end: number): number[] {
    const out = [];
    for (let i = start; i < end; i++) {
        out.push(i);
    }
    return out;
}

function PageNav({ page, maxPage, contentType, version }: IProps) {
    const firstPage = Math.max(1, page - 10);
    const lastPage = Math.min(maxPage, page + 10);
    const pageNumbers = range(firstPage, lastPage + 1);
    const routeTemplate =
        contentType === "texts"
            ? "/$version/texts"
            : contentType === "docs"
              ? "/$version/docs"
              : "/$version/default-content";
    if (pageNumbers.length === 1) {
        return null;
    }
    return (
        <Nav>
            {firstPage > 1 && <Span>. . .</Span>}
            {pageNumbers.map((num) => (
                <StyledLink
                    key={num}
                    to={routeTemplate}
                    params={{ version }}
                    search={(prev) => ({ ...prev, page: num === 1 ? undefined : num })}
                    activeOptions={{ exact: true }}
                    activeProps={{ className: "active" }}
                >
                    {num}
                </StyledLink>
            ))}
            {lastPage < maxPage && <Span>. . .</Span>}
        </Nav>
    );
}

export default PageNav;
